module.exports = __webpack_public_path__ + "static/soderberg-partner-7c306d4a9ec7f5d7d0e05216f5f6f07e.png";